module.exports = __webpack_public_path__ + "0e0922cfef1a3f5c0ab7949d18e0f74b.svg";